class AmyReviewCarousel extends HTMLElement {
  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('[data-amy-review-slide]'));
    this.controls = this.querySelector('[data-amy-review-controls]');
    this.status = this.querySelector('[data-amy-review-status]');
    this.previousButton = this.querySelector('[data-amy-review-previous]');
    this.nextButton = this.querySelector('[data-amy-review-next]');
    this.currentIndex = 0;
    this.delay = Math.max(4, Number(this.dataset.autoplaySeconds) || 7) * 1000;

    if (!this.slides.length) return;

    this.show(0);
    if (this.slides.length < 2) {
      this.controls.hidden = true;
      return;
    }

    this.previousButton.addEventListener('click', () => this.move(-1));
    this.nextButton.addEventListener('click', () => this.move(1));
    this.addEventListener('mouseenter', () => this.stop());
    this.addEventListener('mouseleave', () => this.start());
    this.addEventListener('focusin', () => this.stop());
    this.addEventListener('focusout', () => this.start());
    this.start();
  }

  disconnectedCallback() {
    this.stop();
  }

  show(index) {
    this.currentIndex = (index + this.slides.length) % this.slides.length;
    this.slides.forEach((slide, slideIndex) => {
      const active = slideIndex === this.currentIndex;
      slide.hidden = !active;
      slide.setAttribute('aria-hidden', active ? 'false' : 'true');
    });
    if (this.status) this.status.textContent = `${this.currentIndex + 1} / ${this.slides.length}`;
  }

  move(direction) {
    this.show(this.currentIndex + direction);
    this.start();
  }

  start() {
    this.stop();
    if (this.slides.length > 1 && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      this.timer = window.setInterval(() => this.show(this.currentIndex + 1), this.delay);
    }
  }

  stop() {
    if (this.timer) window.clearInterval(this.timer);
  }
}

if (!customElements.get('amy-review-carousel')) {
  customElements.define('amy-review-carousel', AmyReviewCarousel);
}
